import React, { useEffect, useState, useRef } from "react";
import "../../styles/desktop/CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../API/FeedBackLuzes";

const GroupLightComponent = () => {
  const groupRefs = useRef({
    grupo19: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo19: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      console.log(`Status das luzes: ${statusDasLuzesFlex35}`);
      setLoading(false);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 3000);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo19: statusDasLuzesFlex35.includes("1T10") && !statusDasLuzesFlex35.includes("1T00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      <div className="group" id="campoGroup-pagina2">

        {/* Grupo 19 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo19}
          groupId="grupo19"
          descricao="Elevador Social"
          imageUrl={imageStates.grupo19 ? Ligado : Desligado}
          onCommand="1T10"
          offCommand="1T00"
          x={42.1}
          y={60}
          width={2.9}
          height={4.5}
          imageState={imageStates.grupo19}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo19}
          groupId="grupo19"
          descricao="Elevador Social"
          imageUrl={imageStates.grupo19 ? Ligado : Desligado}
          onCommand="1T10"
          offCommand="1T00"
          x={31.3}
          y={60}
          width={2.9}
          height={4.5}
          imageState={imageStates.grupo19}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Legenda de acionamentos */}
        
        <div id="campo-clickable-element-lazer" className="campo-clickable-element">
          <div
            id="clickable-element"
            className="clickable-element-last"
            onClick={() => {
              handleToggleLightGroup('grupo19', !imageStates.grupo19);
              groupRefs.current.grupo19.current.sendCommand(
                groupRefs.current.grupo19.current.props.descricao,
                imageStates.grupo19 ? groupRefs.current.grupo19.current.props.offCommand : groupRefs.current.grupo19.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo19 ? 'Highlighted' : ''}`}>19</p>
            <p className="textBar">Elevador Social</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(GroupLightComponent);